<template>
  <div class="">
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="queryParams.packetName" placeholder="套餐包名"/>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="queryParams.status" placeholder="支付状态" style="width: 200px">
                <el-option :value="1" label="充值成功" />
                <el-option :value="2" label="加包成功" />
                <el-option :value="3" label="退订" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select @focus="loadAgent" claerable filterable allow-create default-first-option v-model="queryParams.agentId" placeholder="请选择代理商">
                <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-date-picker v-model="queryParams.selectDatetimest" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-date-picker v-model="queryParams.selectDatetimeed" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <label style="padding-left: 3px;">
            <el-button style="padding-left: 10px;" @click="showToggle" type="primary" plain size="small">
              {{btnText}}
            </el-button>
            <el-button @click="list(1)" type="primary" plain size="small" icon="el-icon-search">搜索</el-button>

            <el-button @click="download" type="primary" plain size="small" icon="el-icon-download">导出</el-button>
          </label>
        </div>

        <el-table v-loading="loading"
                  element-loading-text="加载中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)" class="el-ll"  show-summary sum-text="合计" :summary-method="getSumMoney" ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'10px,0',textAlign:'center'}" :max-height="maxHeight" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" style="width: 100%;margin-top: 1%" border>
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="id" label="ID" width="200">
          </el-table-column>
          <el-table-column prop="iccid" label="iccid" width="200">
          </el-table-column>
          <el-table-column prop="agentName" label="代理商" min-width="180">
          </el-table-column>
          <el-table-column prop="ordName" label="交易名称" min-width="160">
          </el-table-column>
          <el-table-column prop="price" label="交易金额" min-width="120">
          </el-table-column>
          <el-table-column prop="packetName" show-overflow-tooltip label="套餐名称" min-width="200">
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.payType==='w'">微信支付</div>
              <div v-if="scope.row.payType==='b'">余额成功</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="180">
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="4"></pagination>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'financialFlow',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      loading: false,
      maxHeight: 500,
      oneCardType: '',
      agents: [],
      agent: '',
      ordType: '',
      payType: '',
      agentId: '',
      parentId: '',
      validateType: '',
      dialogFormVisible: false,
      multipleSelection: [],
      options: [],
      tableData: [],
      inputNum: '',
      inputNumber: '',
      cards: {},
      type: '',
      isDisabled: true,
      cardTypeList: [],
      iccids: '',
      status: '',

      sumMoney: {
        profitPrice: 0,
        price: 0
      },
      isShow: true,
      btnText: '更多',
      queryParams:{
        selectDatetimest: '',
        selectDatetimeed: '',
        current:1,
        size:10,
        status:'',
        agentId:'',
        packetName:''
      },
      agentJs: require('../../../api/agent'),
      financeJs: require('../../../api/finance'),
      loading:false,
    }
  },
  created() {
    this.showToggle()
  },
  methods: {
    dataSearchSt(data) {
      this.queryParams.selectDatetimest=data
    },
    dataSearchEd(data) {
      this.queryParams.selectDatetimeed=data
    },
    loadAgent(){
      this.agentJs.getAgentList({current:1,size:999999,agentName:null}).then(res=>{
        res.data.data.rows.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agents.push(map)
        })

      })
    },
    showToggle() {
      this.btnText = '更多'
      this.isShow = !this.isShow
      if (this.isShow) {
        this.btnText = '更多'
      } else {
        this.btnText = '更多'
      }
    },

    list(page) {
      let _this = this
      _this.loading = true
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.queryParams.selectDatetimeed === null) {
        _this.queryParams.selectDatetimeed = ''
      }
      if (_this.queryParams.selectDatetimest === null) {
        _this.queryParams.selectDatetimest = ''
      }
      _this.queryParams.current = page
      _this.queryParams.size =_this.$refs.pagination.size
      _this.financeJs.getFinanceList(_this.queryParams)
              .then(response => {
                if(response.data.code==='0'){
                  _this.loading=false
                  _this.tableData = response.data.data.rows
                  _this.$refs.pagination.render(page, response.data.data.total)
                  //合计
                  _this.financeJs.getSumMoneyLs(_this.queryParams)
                  .then(res=>{
                    _this.sumMoney = res.data.data.rows
                    //_this.$refs.pagination.render(page, response.data.data.total)
                  })
                }else{
                  _this.loading=false
                  _this.tableData=[]
                }
              }).catch(err=>{
        _this.loading=false
      })

    },

    getSumMoney(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (this.sumMoney.price === 0) {
          return
        }
        switch (column.property) {
          case 'price':
            sums[index] = this.sumMoney.toFixed(2) + '元' //值取自后台
            break
          default:
            break
        }
      })
      return sums
    },
    download() {
      let _this = this
      _this
        .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.financeJs.importFinanceList(_this.queryParams)
            .then(res => {
              if(res.data.code==='0'){
                _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
              }else{
                _this.$alert(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
    }
  }
}
</script>

<style scoped>

  ::v-deep .el-table .el-table__cell {
    padding: 0px;
    text-align: center;
  }

/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
.el-main,
.el-header {
  padding: 20px !important;
}

/deep/.el-table_1_column_6 .is-leaf .cell {
  overflow: visible !important;
}
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
</style>
